export enum IndustryGroup {
    NOT_APPLICABLE = "0000",
    ENERGY = "1010",
    MATERIALS = "1510",
    CAPITAL_GOODS = "2010",
    COMMERCIAL_AND_PROFESSIONAL_SERVICES = "2020",
    TRANSPORTATION = "2030",
    AUTOMOBILE_AND_COMPONENTS = "2510",
    CONSUMER_DURABLES_AND_APPAREL = "2520",
    CONSUMER_SERVICES = "2530",
    MEDIA = "2540",
    RETAILING = "2550",
    FOOD_AND_STABLES_RETAILING = "3010",
    FOOD_BEVERAGE_AND_TOBACCO = "3020",
    HOUSEHOLD_AND_PERSONAL_PRODUCTS = "3030",
    HEALTH_CARE_EQUIPMENT_AND_SERVICES = "3510",
    PHARMACEUTICALS = "3520",
    BANKS = "4010",
    DIVERSIFIED_FINANCIALS = "4020",
    INSURANCE = "4030",
    SOFTWARE_AND_SERVICES = "4510",
    TECHNOLOGY_HARDWARE_AND_EQUIPMENT = "4520",
    SEMICONDUCTORS_AND_SEMICONDUCTOR_EQUIPMENT = "4530",
    TELECOMMUNICATION_SERVICES = "5010",
    MEDIA_AND_ENTERTAINMENT = "5020",
    UTILITIES = "5510",
    REAL_ESTATE = "6010",
    CLASSIFICATION_PENDING = "9999"
}

export function industryGroupDescription(industryGroup: IndustryGroup): string {
    switch (industryGroup) {
        case IndustryGroup.NOT_APPLICABLE:
            return "Not Applicable";
        case IndustryGroup.ENERGY:
            return "Energy";
        case IndustryGroup.MATERIALS:
            return "Materials";
        case IndustryGroup.CAPITAL_GOODS:
            return "Capital Goods";
        case IndustryGroup.COMMERCIAL_AND_PROFESSIONAL_SERVICES:
            return "Commercial & Professional Services";
        case IndustryGroup.TRANSPORTATION:
            return "Transportation";
        case IndustryGroup.AUTOMOBILE_AND_COMPONENTS:
            return "Automobiles & Components";
        case IndustryGroup.CONSUMER_DURABLES_AND_APPAREL:
            return "Consumer Durables & Apparel";
        case IndustryGroup.CONSUMER_SERVICES:
            return "Consumer Services";
        case IndustryGroup.MEDIA:
            return "Media";
        case IndustryGroup.RETAILING:
            return "Retailing";
        case IndustryGroup.FOOD_AND_STABLES_RETAILING:
            return "Food & Staples Retailing";
        case IndustryGroup.FOOD_BEVERAGE_AND_TOBACCO:
            return "Food Beverage & Tobacco";
        case IndustryGroup.HOUSEHOLD_AND_PERSONAL_PRODUCTS:
            return "Household & Personal Products";
        case IndustryGroup.HEALTH_CARE_EQUIPMENT_AND_SERVICES:
            return "Health Care Equipment & Services";
        case IndustryGroup.PHARMACEUTICALS:
            return "Pharmaceuticals";
        case IndustryGroup.BANKS:
            return "Banks";
        case IndustryGroup.DIVERSIFIED_FINANCIALS:
            return "Diversified Financials";
        case IndustryGroup.INSURANCE:
            return "Insurance";
        case IndustryGroup.SOFTWARE_AND_SERVICES:
            return "Software & Services";
        case IndustryGroup.TECHNOLOGY_HARDWARE_AND_EQUIPMENT:
            return "Technology Hardware & Equipment";
        case IndustryGroup.SEMICONDUCTORS_AND_SEMICONDUCTOR_EQUIPMENT:
            return "Semiconductors & Semiconductor Equipment";
        case IndustryGroup.TELECOMMUNICATION_SERVICES:
            return "Telecommunication Services";
        case IndustryGroup.MEDIA_AND_ENTERTAINMENT:
            return "Media & Entertainment";
        case IndustryGroup.UTILITIES:
            return "Utilities";
        case IndustryGroup.REAL_ESTATE:
            return "Real Estate";
        case IndustryGroup.CLASSIFICATION_PENDING:
            return "Classification Pending";
    }
}
